export default {
  name: 'time',
  namespaced: true,
  state: {
    current: Date.now(),
  },
  mutations: {
    refresh(state, now) {
      state.current = now
    },
  },
  actions: {
    refresh({ commit }) {
      commit('refresh', Date.now())
    },
  },
}
